import { render, staticRenderFns } from "./LoginBussiness.vue?vue&type=template&id=1d6d4508&"
import script from "./LoginBussiness.vue?vue&type=script&lang=js&"
export * from "./LoginBussiness.vue?vue&type=script&lang=js&"
import style0 from "./LoginBussiness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports